export default () => ({
  title: "AddTeamHiddenByDefault",
  type: "object",
  properties: {
    value: {
      title: "Active",
      type: "boolean",
      default: false,
    },
  },
});
